import React from "react";

export default function OpenAppButton(props) {
    const { popUpState, setPopUpState, transparent, game } = props;

    const openAppUrl = `https://fitgames.tw/applink`;

    const handleOpenApp = () => {
        window.open(openAppUrl, "_self");
    }

    const handlePopUp = (props) => {
        setPopUpState({
            isOpen: !popUpState.isOpen,
            popUpType: props,
        })
    }

    const popup = {
        get type () {
            return game ? "normalGame" : "normal"
        }
    }

    const ButtonType = (props) => {
        const { transparent, game } = props;

        if (transparent) {
            return (
                <div>
                    <button
                        className={game ? "web-header-app-btn-samll-transparent-game" : "web-header-app-btn-samll-transparent"}
                        onClick={() => handleOpenApp()}
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.3)" }}>
                        開啟應用程式
                    </button>

                    <button
                        className={game ? "web-header-app-btn-big-transparent-game" : "web-header-app-btn-big-transparent"}
                        onClick={() => handlePopUp(popup.type)}
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.3)" }}>
                        開啟應用程式
                    </button>
                </div>
            );
        }

        return (
            <div>
                <button
                    className={game ? "web-header-app-btn-samll-game" : "web-header-app-btn-samll"}
                    onClick={() => handleOpenApp()}>
                    開啟應用程式
                </button>

                <button
                    className={game ? "web-header-app-btn-big-game" : "web-header-app-btn-big"}
                    onClick={() => handlePopUp(popup.type)}>
                    開啟應用程式
                </button>
            </div>
        );
    }

    return (
        <div>
            <ButtonType transparent={transparent} game={game} />
        </div>
    );
}